/**
 */

define('directives/myservices/appIcon/appIcon.directives',['app'], function (app) {
    app.directive('appIcon', ['HuaweiTrade', 'OpenGW', 'auiDialog', '$filter', 'auiUpload', function (HuaweiTrade, OpenGW, auiDialog, $filter, auiUpload) {
        var timeout;
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            templateUrl: '../refactor/directives/myservices/appIcon/appIcon.html',
            link: function ($scope, $element, attrs, ngModelCtrl) {

                //上传图片
                $scope.uploadImg = function (files, size, fileType, ext, obj, type, num) {
                    var options = {size: size, type: fileType, ext: ext, scene: num};
                    auiUpload.upload2openApp(files, (sysParamCfg.switchConf.isAgcSupportIcon ? '23' : '3'), options).then(function (fileUrl) {
                        if (type == 'appIcon') {
                            imgCheck(obj, type, fileUrl, ['216', '216']);
                        }
                    }).catch(function (data) {
                        if (data && data.NSP_STATUS) {
                            auiDialog.fail($filter('auiErrorCode')(data.NSP_STATUS, data.serviceName));
                        }
                    });
                }

                //判断图片的分辨率是否符合规则
                function imgCheck(obj, type, fileUrl, array, num) {
                    var imgtemp = new Image();
                    imgtemp.src = fileUrl;
                    imgtemp.onload = function () {
                        if ((imgtemp.height == array[0] && imgtemp.width == array[1])) {
                            if (!angular.isArray(obj)) {
                                obj['appIcon'] = fileUrl;
                            }
                        } else {
                            auiDialog.fail('图片尺寸不符合要求。');
                        }
                        $scope.$apply();
                    };
                    imgtemp.onerror = function () {
                        if (fileUrl) {
                            auiDialog.fail('图片不符合要求或网络错误。');
                        }

                    };
                }
            }
        }
    }]);
});
